/**
 * useMediaQuery — the few responsive decisions that CSS cannot express.
 *
 * Phase 6: some controls must exist in ONE place only (a filter drawer instead
 * of an inline filter bar, a sticky mobile CTA instead of an in-flow one).
 * Rendering both and hiding one with CSS would duplicate ids and state, so the
 * choice is made here, once, from the same breakpoints as the CSS contract.
 */
import { useEffect, useState } from "react";

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => (typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(query).matches
      : false),
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

// Breakpoint contract (design.md §8): mobile <640, tablet 640–1023, desktop ≥1024.
export const useIsMobile = () => useMediaQuery("(max-width: 639px)");

export default useMediaQuery;
